(ns manage.campaign.link.link-campaign-modal
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/CircularProgress$default" :as CircularProgress]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [common.modal.view :refer [defmodal modal-v2]]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.campaign :as cq]
            [common.util :refer [spread-props]]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field hint]]
            [common.widgets.input :as input]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :as uix :refer [$]]
            [uix.re-frame :refer [use-subscribe]]))

(defmodal link-campaign :campaign/link
  {:sx {".MuiPaper-root" {:overflowY "visible"}}}
  [{:keys [link-mode]}]
  (let [[campaign set-campaign] (uix/use-state nil)

        {:keys [advertiser-id]} (use-subscribe [:url-context])
        {campaigns :data} (use-query (cq/campaigns-query {:advertiser-id advertiser-id}))
        sso-token (use-subscribe [:common.os/token])
        options (map #(identity {:label (:name %) :value %}) campaigns)
        project-id (use-subscribe [:common.os/project-id])

        is-campaign-create-allowed (use-subscribe [:resource.user/allowed? "campaigns.create"])

        [campaign-name set-campaign-name] (uix/use-state "")
        [creating-campaign set-creating-campaign] (uix/use-state false)
        {create-campaign :mutate} (use-mutation (cq/create-campaign-mutation {:advertiser-id advertiser-id}))
        create-linked-campaign (uix/use-callback
                                (fn [name]
                                  (set-creating-campaign true)
                                  (create-campaign {:name name :WPPOSProjectIds [project-id]}
                                                   #js {:onSuccess (fn []
                                                                     (set-creating-campaign false)
                                                                     (rf/dispatch-sync [:common.os/resolve-os-context])
                                                                     (rf/dispatch-sync [:common.resource.sso/sso-login
                                                                                        {:token {:access-token sso-token}
                                                                                         :on-failure nil}])
                                                                     (rf/dispatch [:modal/close]))}))
                                [create-campaign project-id sso-token])

        link-mode? (= link-mode :link)

        {patch-campaign-wpp-project :mutate} (use-mutation (cq/patch-campaign-wpp-project {:campaign-id (:id campaign)}))]
    ($ modal-v2
       {:title (if link-mode? "Link campaign" "Create campaign")
        :footer ($ Stack
                   {:direction "row"
                    :sx #js {:padding 0
                             :alignItems "right"
                             :gap 1}}
                   ($ Button
                      {:variant "text"
                       :sx #js {:color "text.primary"}
                       :onClick #(rf/dispatch [:modal/close])}
                      "Cancel")
                   ($ Button
                      {:variant "contained"
                       :onClick #(if link-mode?
                                   (patch-campaign-wpp-project {:operation "add" :WPPOSProjectId project-id}
                                                               #js {:onSuccess (fn []
                                                                                 (rf/dispatch-sync [:common.os/resolve-os-context])
                                                                                 (rf/dispatch-sync [:common.resource.sso/sso-login
                                                                                                    {:token {:access-token sso-token}
                                                                                                     :on-failure nil}])
                                                                                 (rf/dispatch [:modal/close]))})
                                   (create-linked-campaign campaign-name))
                       :disabled (if link-mode? (not campaign) (= campaign-name ""))}
                      (if link-mode? "Link to project" "Create and link campaign")))}
       ($ Stack
          {:sx #js {:py 2
                    :minWidth 480
                    :minHeight 120}}
          (if link-mode?
            ($ form-field
               {:label "Campaign"
                :required? true}
               (r/as-element
                [dropdown {:options options
                           :value campaign
                           :on-change (fn [value]
                                        (set-campaign value))
                           :placeholder "Search campaign..."
                           :value-renderer (fn [^js item]
                                             (if (.-create item)
                                               (.-value item)
                                               (.-label item)))
                           :render-option (fn [^js props option ^js _option-state _owner-state]
                                            (if (.-create option)
                                              ($ Typography
                                                 (spread-props props
                                                               {:component "li"
                                                                :sx #js {:borderTop "1px solid #ddd"
                                                                         :mt 0.5
                                                                         :color "primary.main"
                                                                         "&.MuiAutocomplete-option" #js {:pt 1}}})
                                                 (.-label option))
                                              ($ :li props
                                                 (.-label option))))
                           :disabled? creating-campaign
                           :input-props (fn [^js params]
                                          {:endAdornment ($ :<>
                                                            (when creating-campaign
                                                              ($ CircularProgress {:size 20}))
                                                            (.. params -InputProps -endAdornment))})
                           :filter-options (fn dropdown-filter-options [^js options ^js state]
                                             (let [input (.toLowerCase (.-inputValue state))
                                                   opts (if (seq input)
                                                          (.filter options (fn dropdown-filter-test [option]
                                                                             (or (when (.-value option)
                                                                                   (.. option -value toString toLowerCase (includes input)))
                                                                                 (.. option -label toLowerCase (includes input)))))
                                                          options)]
                                               (if (empty? opts)
                                                 (-> [{:label (cond-> "No campaigns"
                                                                (not is-campaign-create-allowed) (str " - please contact support."))
                                                       :disabled? true}]
                                                     clj->js)
                                                 opts)))}]))
            ($ form-field
               {:label "Name"
                :required? true}
               ($ input/input
                  {:type "text"
                   :data-testid "campaign-name-input"
                   :autoFocus true
                   :placeholder "Type a name..."
                   :value campaign-name
                   :onChange #(set-campaign-name (-> % .-target .-value))})
               ($ hint "How is your campaign best described?")))))))
